<template>
  <div class="carousel-add">
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="标题：">
        <el-input
          v-model="form.informationTitle"
          placeholder="请输入不超过20个字"
          maxlength="20"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片：" class="uploadImg">
        <upload
          :disabled="true"
          :url="form.informationUrl"
          @successUpload="handleSuccessUpload"
          prompt="图文封面：建议尺寸400*300，大小不超过2M，支持Jpg、Png格式"
        />
      </el-form-item>
      <el-form-item label="图文内容：">
        <editor
          :disabled="true"
          :editContent="form.informationContent"
          @getValue="getEditorContent"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getInformation } from '@/api/carousel';
import Upload from '@/components/Upload/index.vue';
import Editor from '@/components/Editor';

export default {
  name: 'CarouselDetail',
  data() {
    return {
      form: {
        informationTitle: '',
        informationUrl: '',
        informationContent: '',
      },
    };
  },
  components: {
    Upload,
    Editor,
  },
  mounted() {
    this.getInformation();
  },
  methods: {
    getInformation() {
      const { id } = this.$route.query;
      getInformation(id).then((res) => {
        if (res.success) {
          const { createTime, ...rest } = res.data;
          this.form = rest;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSuccessUpload(url) {
      this.form.informationUrl = url;
    },
    getEditorContent(value) {
      this.form.informationContent = value;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.carousel-add
  padding-top 100px
  .el-form
    width 910px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      text-align center
</style>
